'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getEndpoint = require('../get-endpoint');

var _getEndpoint2 = _interopRequireDefault(_getEndpoint);

var _config = require('../config');

var _dataProvider = require('../data-provider');

var _dataProvider2 = _interopRequireDefault(_dataProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Gets the current user balance from OpenBet
 * @param {GetBalanceParamsType} params The function parameters
 * @param {TunnelType} params.tunnel The request tunnel
 * @returns {Promise<string>} The current user balance
 */
exports.default = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(params) {
        var tunnel, endpoint, proxyAgent, response;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        tunnel = params.tunnel;
                        endpoint = (0, _getEndpoint2.default)('ob', '/bal/en-gb?action=GetBalance&external=false');
                        proxyAgent = (0, _config.getProxy)('ob');
                        _context.next = 5;
                        return (0, _dataProvider2.default)(endpoint, tunnel, {
                            agent: proxyAgent
                        });

                    case 5:
                        response = _context.sent;

                        if (!(response.result !== 'OK' && !response.amount)) {
                            _context.next = 9;
                            break;
                        }

                        tunnel.log.warn('Failed to fetch balance', response.message);
                        throw new Error('Failed to fetch balance');

                    case 9:
                        return _context.abrupt('return', response.amount);

                    case 10:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    function getBalance(_x) {
        return _ref.apply(this, arguments);
    }

    return getBalance;
}();
//# sourceMappingURL=balance.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/balance/balance.js
// module id = 441
// module chunks = 0